import { div } from "framer-motion/client"
import styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";
import { Observer } from "mobx-react";
import { getMobileOperatingSystem } from "../constants/utils";
import MCQOption from "../screens/Questionare/MCQOption";
import QuestionareStore from "../stores/QuestionareStore";
import { useState } from "react";

const isiOS = getMobileOperatingSystem() === "iOS";

const IC_Component = ({item}) => {
    //caption
    //display text
    //helper text
    //image/ option/ select_type: text_area
    const [inputVal, setInputVal] = useState('')
    return (
      <Observer>
        {()=>{return(
          <div>
            {item.caption_text && (
                <p
                className={isiOS ? iStyles.QuestionLabel : styles.QuestionLabel}
              >
                {item.caption_text}
              </p>
            )}

            {(item.display_text && !item.image_file)&& (
              <p className={isiOS ? iStyles.Question : styles.Question} >
                {item.display_text}
              </p>
            )}

            {item.helper_text && (
                <p
                className={isiOS ? iStyles.QuestionLabel : styles.QuestionLabel}
              >
                {item.helper_text}
              </p>
            )}    


            {/* render optons if present */}
            {/* render options if select_type is multi_select or single_select */}
            {(item.select_type === "multi_select" || item.select_type === "single_select") && item.options.length > 0 && (
              <div style={{ 
                height: '50vh', 
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                }}>
                {item.options.map((option, index) => (
                  <MCQOption
                    isSelected={
                      (QuestionareStore.selectedOptions[QuestionareStore.currentStepIndex] || []).includes(index)
                    }
                    key={index}
                    text={option.option_name}
                    onClick={() => QuestionareStore.selectOption(index)}
                  />
                ))}
              </div>
            )}
            
            


            

        </div>
        )}}

      </Observer>
    )
}

export default IC_Component